<template>
  <portal to="modals">
    <mj-modal
      name="root-modal"
      v-bind="$attrs"
      adaptive
      height="auto"
      @closed="onClose"
      @before-open="beforeOpen"
    >
      <component
        :is="name"
        :params="params"
      />
    </mj-modal>
  </portal>
</template>

<script>
export default {
  name: 'ModalWindow',

  data() {
    return {
      name: null,
      params: {},
    };
  },

  methods: {
    onClose() {
      this.$emit('close');
    },

    beforeOpen(event) {
      this.name = event.params.name;
      this.params = event.params;
    },
  },

};
</script>
